import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { NotificationDTO } from "../../domain/contracts/notifications";

export const notificationsApi = {
  list: (params?: { limit?: number; offset?: number; unreadOnly?: boolean }) => {
    const url = new URL(`${config.apiUrl}/notifications`);
    if (params?.limit != null) url.searchParams.set("limit", String(params.limit));
    if (params?.offset != null) url.searchParams.set("offset", String(params.offset));
    if (params?.unreadOnly) url.searchParams.set("unreadOnly", "true");
    return fetcher.get<{
      items: NotificationDTO[];
      meta: { total: number; offset: number; limit: number };
    }>(url.toString());
  },

  unreadCount: () =>
    fetcher.get<{ count: number }>(`${config.apiUrl}/notifications/unread-count`),

  markRead: (id: string) =>
    fetcher.patch<NotificationDTO>(
      `${config.apiUrl}/notifications/${id}/read`,
      {},
    ),

  markAllRead: () =>
    fetcher.post<{ ok: true }>(
      `${config.apiUrl}/notifications/mark-all-read`,
      {},
    ),
};
